import React from 'react';
import { motion, Variants } from 'framer-motion';
import logo from '@/assets/logo-cormorantgaramond.svg';
import '@/components/sections/Hero.scss';

const FADE_IN_VARIANTS: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1.5, ease: 'easeIn' } },
};

const TEXT_UP_VARIANTS: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: (custom: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 2.5, ease: [0.25, 0.1, 0.25, 1], delay: custom },
  }),
};

const Hero: React.FC = () => (
  <motion.section id="hero" className="hero" initial="hidden" animate="visible" variants={FADE_IN_VARIANTS}>
    <div className="hero__content">
      <motion.h1 className="hero__title" variants={TEXT_UP_VARIANTS} custom={0}>
        <img src={logo} alt="Ephemera Partners" className="hero__logo-img" />
      </motion.h1>
      <span>
        <motion.h2 className="hero__subtitle" variants={TEXT_UP_VARIANTS} custom={0.3}>
          Investing in moments that <span>resonate.</span>
        </motion.h2>
      </span>
      <motion.h5 className="hero__bullets" variants={TEXT_UP_VARIANTS} custom={0.6}>
        Real Estate • Aviation • Culture
      </motion.h5>
    </div>
  </motion.section>
);

export default Hero;
